import { render, staticRenderFns } from "./OpenInBrowser.vue?vue&type=template&id=a49b95ae&scoped=true"
import script from "./OpenInBrowser.vue?vue&type=script&setup=true&lang=ts"
export * from "./OpenInBrowser.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./OpenInBrowser.vue?vue&type=style&index=0&id=a49b95ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a49b95ae",
  null
  
)

export default component.exports